
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { GestionEmpleado } from '../models/gestionEmpleado.model';
import { GestionEmpleadoRequest } from '../models/gestionEmpleadoRequest.model';
import { TramosCodigoEmpleado } from '../models/tramosCodigoEmpleado.model';
  
@Injectable()
export class GestionEmpleadoService extends HttpClientBaseService implements IServiceBase<GestionEmpleado> {

    constructor(_http: HttpClient) {
        super(_http, 'gestionEmpleados/','', false);
    }

    getAllModels(parentId?: any, params?: HttpParams): Observable<GestionEmpleado[]> {
        throw new Error('Method not implemented.');
    }

    getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<GestionEmpleado>> {
        throw new Error('Method not implemented.');
    }

    getModel(id: any, parentId?: any): Observable<GestionEmpleado> {
        throw new Error('Method not implemented.');
    }

    getAllModelsByCompany(request: GestionEmpleadoRequest): Observable<any> {
        return this.http.post<any>(this.getConcatUrl(), request);
    }

    setCompanyPermissions(id: string, selectedCompanies: number[]) {
        const url = `${this.getConcatUrl()}${id}/companyPermissions/`;
        return this.http.post(url, selectedCompanies);
    }

    getCompanyPermissionsByUserId(id: string): Observable<number[]> {
        const url = `${this.getConcatUrl()}${id}/companyPermissions/`;
        return this.http.get<number[]>(url);
    }
}
  